// extracted by mini-css-extract-plugin
export var footerTagline = "footerTagline-module--footerTagline--52c46";
export var footerTaglineWrapper = "footerTagline-module--footerTaglineWrapper--4fe97";